function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Icon } from '@iconify/react';
import playCircle from '@iconify/icons-mdi/play-circle';
import pauseCircle from '@iconify/icons-mdi/pause-circle';
import skipPrevious from '@iconify/icons-mdi/skip-previous';
import skipNext from '@iconify/icons-mdi/skip-next';
import fastForward from '@iconify/icons-mdi/fast-forward';
import rewind from '@iconify/icons-mdi/rewind';
import volumeHigh from '@iconify/icons-mdi/volume-high';
import volumeMute from '@iconify/icons-mdi/volume-mute';
import repeat from '@iconify/icons-mdi/repeat';
import repeatOff from '@iconify/icons-mdi/repeat-off';

var H5AudioPlayer = function (_Component) {
  _inherits(H5AudioPlayer, _Component);

  _createClass(H5AudioPlayer, null, [{
    key: "addHeadingZero",
    value: function addHeadingZero(num) {
      return num > 9 ? num.toString() : "0".concat(num);
    }
  }, {
    key: "getPosX",
    value: function getPosX(event) {
      if (event instanceof MouseEvent) {
        return event.pageX || event.clientX;
      } else {
        return event.touches[0].pageX;
      }
    }
  }, {
    key: "throttle",
    value: function throttle(func, limit) {
      var inThrottle = false;
      return function (arg) {
        if (!inThrottle) {
          func(arg);
          inThrottle = true;
          setTimeout(function () {
            return inThrottle = false;
          }, limit);
        }
      };
    }
  }, {
    key: "getDisplayTimeBySeconds",
    value: function getDisplayTimeBySeconds(seconds) {
      if (!isFinite(seconds)) {
        return '00:00';
      }

      var addHeadingZero = H5AudioPlayer.addHeadingZero;
      var min = addHeadingZero(Math.floor(seconds / 60));
      var sec = addHeadingZero(Math.floor(seconds % 60));
      return "".concat(min, ":").concat(sec);
    }
  }]);

  function H5AudioPlayer(props) {
    var _this;

    _classCallCheck(this, H5AudioPlayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(H5AudioPlayer).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", void 0);

    _defineProperty(_assertThisInitialized(_this), "audio", void 0);

    _defineProperty(_assertThisInitialized(_this), "volumeControl", void 0);

    _defineProperty(_assertThisInitialized(_this), "progressBar", void 0);

    _defineProperty(_assertThisInitialized(_this), "container", void 0);

    _defineProperty(_assertThisInitialized(_this), "lastVolume", void 0);

    _defineProperty(_assertThisInitialized(_this), "timeOnMouseMove", void 0);

    _defineProperty(_assertThisInitialized(_this), "listenTracker", void 0);

    _defineProperty(_assertThisInitialized(_this), "volumeAnimationTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "downloadProgressAnimationTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "togglePlay", function (e) {
      e.stopPropagation();

      if (_this.audio.paused && _this.audio.src) {
        var audioPromise = _this.audio.play();

        audioPromise.then(null).catch(function (err) {
          var onPlayError = _this.props.onPlayError;
          onPlayError && onPlayError(new Error(err));
        });
      } else if (!_this.audio.paused) {
        _this.audio.pause();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickVolumeButton", function () {
      if (_this.audio.volume > 0) {
        _this.lastVolume = _this.audio.volume;
        _this.audio.volume = 0;
      } else {
        _this.audio.volume = _this.lastVolume;
      }

      _this.setState({
        currentVolumePos: "".concat((_this.audio.volume * 100).toFixed(0), "%"),
        hasVolumeAnimation: true
      });

      clearTimeout(_this.volumeAnimationTimer);
      _this.volumeAnimationTimer = setTimeout(function () {
        _this.setState({
          hasVolumeAnimation: false
        });
      }, 100);
    });

    _defineProperty(_assertThisInitialized(_this), "handleVolumnControlMouseDown", function (event) {
      event.stopPropagation();

      var _this$getCurrentVolum = _this.getCurrentVolume(event.nativeEvent),
          currentVolume = _this$getCurrentVolum.currentVolume,
          currentVolumePos = _this$getCurrentVolum.currentVolumePos;

      _this.audio.volume = currentVolume;

      _this.setState({
        isDraggingVolume: true,
        currentVolumePos: currentVolumePos
      });

      if (event.nativeEvent instanceof MouseEvent) {
        window.addEventListener('mousemove', _this.handleWindowMouseOrTouchMove);
        window.addEventListener('mouseup', _this.handleWindowMouseOrTouchUp);
      } else {
        window.addEventListener('touchmove', _this.handleWindowMouseOrTouchMove);
        window.addEventListener('touchend', _this.handleWindowMouseOrTouchUp);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleWindowMouseOrTouchMove", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var windowSelection = window.getSelection();

      if (windowSelection && windowSelection.type === 'Range') {
        windowSelection.empty();
      }

      var _this$state = _this.state,
          isDraggingVolume = _this$state.isDraggingVolume,
          isDraggingProgress = _this$state.isDraggingProgress;

      if (isDraggingVolume) {
        var _this$getCurrentVolum2 = _this.getCurrentVolume(event),
            currentVolume = _this$getCurrentVolum2.currentVolume,
            currentVolumePos = _this$getCurrentVolum2.currentVolumePos;

        _this.audio.volume = currentVolume;

        _this.setState({
          currentVolumePos: currentVolumePos
        });
      } else if (isDraggingProgress) {
        var _this$getCurrentProgr = _this.getCurrentProgress(event),
            _currentTime = _this$getCurrentProgr.currentTime,
            currentTimePos = _this$getCurrentProgr.currentTimePos;

        _this.timeOnMouseMove = _currentTime;

        _this.setState({
          currentTimePos: currentTimePos
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleWindowMouseOrTouchUp", function (event) {
      event.stopPropagation();

      _this.setState(function (prevState) {
        if (prevState.isDraggingProgress && isFinite(_this.timeOnMouseMove)) {
          _this.audio.currentTime = _this.timeOnMouseMove;
        }

        return {
          isDraggingVolume: false,
          isDraggingProgress: false
        };
      });

      if (event instanceof MouseEvent) {
        window.removeEventListener('mousemove', _this.handleWindowMouseOrTouchMove);
        window.removeEventListener('mouseup', _this.handleWindowMouseOrTouchUp);
      } else {
        window.removeEventListener('touchmove', _this.handleWindowMouseOrTouchMove);
        window.removeEventListener('touchend', _this.handleWindowMouseOrTouchUp);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentVolume", function (event) {
      if (!_this.volumeControl) {
        return {
          currentVolume: _this.audio.volume,
          currentVolumePos: _this.state.currentVolumePos
        };
      }

      var volumeBarRect = _this.volumeControl.getBoundingClientRect();

      var maxRelativePos = volumeBarRect.width;
      var relativePos = H5AudioPlayer.getPosX(event) - volumeBarRect.left;
      var currentVolume;
      var currentVolumePos;

      if (relativePos < 0) {
        currentVolume = 0;
        currentVolumePos = '0%';
      } else if (relativePos > volumeBarRect.width) {
        currentVolume = 1;
        currentVolumePos = '100%';
      } else {
        currentVolume = relativePos / maxRelativePos;
        currentVolumePos = "".concat(relativePos / maxRelativePos * 100, "%");
      }

      return {
        currentVolume: currentVolume,
        currentVolumePos: currentVolumePos
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDownProgressBar", function (event) {
      event.stopPropagation();

      var _this$getCurrentProgr2 = _this.getCurrentProgress(event.nativeEvent),
          currentTime = _this$getCurrentProgr2.currentTime,
          currentTimePos = _this$getCurrentProgr2.currentTimePos;

      if (isFinite(currentTime)) {
        _this.timeOnMouseMove = currentTime;

        _this.setState({
          isDraggingProgress: true,
          currentTimePos: currentTimePos
        });

        if (event.nativeEvent instanceof MouseEvent) {
          window.addEventListener('mousemove', _this.handleWindowMouseOrTouchMove);
          window.addEventListener('mouseup', _this.handleWindowMouseOrTouchUp);
        } else {
          window.addEventListener('touchmove', _this.handleWindowMouseOrTouchMove);
          window.addEventListener('touchend', _this.handleWindowMouseOrTouchUp);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickLoopButton", function () {
      _this.setState(function (prevState) {
        return {
          isLoopEnabled: !prevState.isLoopEnabled
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickRewind", function () {
      _this.setJumpTime(-_this.props.progressJumpStep);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickForward", function () {
      _this.setJumpTime(_this.props.progressJumpStep);
    });

    _defineProperty(_assertThisInitialized(_this), "setJumpTime", function (time) {
      var _this$audio = _this.audio,
          duration = _this$audio.duration,
          prevTime = _this$audio.currentTime;
      if (!isFinite(duration) || !isFinite(prevTime)) return;
      var currentTime = prevTime + time / 1000;

      if (currentTime < 0) {
        _this.audio.currentTime = 0;
        currentTime = 0;
      } else if (currentTime > duration) {
        _this.audio.currentTime = duration;
        currentTime = duration;
      } else {
        _this.audio.currentTime = currentTime;
      }

      _this.setState({
        currentTimePos: "".concat(currentTime / duration * 100, "%")
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setJumpVolume", function (volume) {
      var newVolume = _this.audio.volume + volume;
      if (newVolume < 0) newVolume = 0;else if (newVolume > 1) newVolume = 1;
      _this.audio.volume = newVolume;

      _this.setState({
        currentVolumePos: "".concat((newVolume * 100).toFixed(0), "%")
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentProgress", function (event) {
      if (!_this.audio.src || !isFinite(_this.audio.currentTime) || !_this.progressBar) {
        return {
          currentTime: 0,
          currentTimePos: '0%'
        };
      }

      var progressBarRect = _this.progressBar.getBoundingClientRect();

      var maxRelativePos = progressBarRect.width;
      var relativePos = H5AudioPlayer.getPosX(event) - progressBarRect.left;

      if (relativePos < 0) {
        relativePos = 0;
      } else if (relativePos > maxRelativePos) {
        relativePos = maxRelativePos;
      }

      var currentTime = _this.audio.duration * relativePos / maxRelativePos;
      return {
        currentTime: currentTime,
        currentTimePos: "".concat((relativePos / maxRelativePos * 100).toFixed(2), "%")
      };
    });

    _defineProperty(_assertThisInitialized(_this), "setListenTrack", function () {
      if (!_this.listenTracker) {
        var listenInterval = _this.props.listenInterval;
        _this.listenTracker = setInterval(function () {
          _this.props.onListen && _this.props.onListen(_this.audio.currentTime);
        }, listenInterval);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearListenTrack", function () {
      if (_this.listenTracker) {
        clearInterval(_this.listenTracker);
        delete _this.listenTracker;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      switch (e.keyCode) {
        case 32:
          if (e.target === _this.container || e.target === _this.progressBar) {
            _this.togglePlay(e);
          }

          break;

        case 37:
          _this.handleClickRewind();

          break;

        case 39:
          _this.handleClickForward();

          break;

        case 38:
          _this.setJumpVolume(_this.props.volumeJumpStep);

          break;

        case 40:
          _this.setJumpVolume(-_this.props.volumeJumpStep);

          break;

        case 76:
          _this.handleClickLoopButton();

          break;

        case 77:
          _this.handleClickVolumeButton();

          break;
      }
    });

    var _volume = props.volume,
        muted = props.muted;
    _this.state = {
      currentTimePos: '0%',
      currentVolumePos: muted ? '0%' : "".concat(_volume * 100, "%"),
      isDraggingProgress: false,
      isDraggingVolume: false,
      isPlaying: false,
      isLoopEnabled: _this.props.loop,
      downloadProgressArr: [],
      hasVolumeAnimation: false,
      hasDownloadProgressAnimation: false
    };
    _this.lastVolume = _volume;
    _this.timeOnMouseMove = 0;
    return _this;
  }

  _createClass(H5AudioPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var audio = this.audio;

      if (this.props.muted) {
        audio.volume = 0;
      } else {
        audio.volume = this.lastVolume;
      }

      audio.addEventListener('error', function (e) {
        _this2.props.onError && _this2.props.onError(e);
      });
      audio.addEventListener('canplay', function (e) {
        _this2.props.onCanPlay && _this2.props.onCanPlay(e);
      });
      audio.addEventListener('canplaythrough', function (e) {
        _this2.props.onCanPlayThrough && _this2.props.onCanPlayThrough(e);
      });
      audio.addEventListener('play', function (e) {
        _this2.setState({
          isPlaying: true
        });

        _this2.setListenTrack();

        _this2.props.onPlay && _this2.props.onPlay(e);
      });
      audio.addEventListener('abort', function (e) {
        _this2.clearListenTrack();

        var autoPlayAfterSrcChange = _this2.props.autoPlayAfterSrcChange;

        if (autoPlayAfterSrcChange) {
          _this2.audio.play();
        } else {
          _this2.setState({
            isPlaying: false,
            currentTimePos: '0%'
          });
        }

        _this2.props.onAbort && _this2.props.onAbort(e);
      });
      audio.addEventListener('ended', function (e) {
        _this2.clearListenTrack();

        _this2.props.onEnded && _this2.props.onEnded(e);
      });
      audio.addEventListener('pause', function (e) {
        _this2.clearListenTrack();

        if (!_this2.audio) return;

        _this2.setState({
          isPlaying: false
        });

        _this2.props.onPause && _this2.props.onPause(e);
      });
      audio.addEventListener('progress', function (e) {
        var audio = e.target;
        var downloadProgressArr = [];

        for (var i = 0; i < audio.buffered.length; i++) {
          var bufferedStart = audio.buffered.start(i);
          var bufferedEnd = audio.buffered.end(i);
          downloadProgressArr.push({
            left: "".concat(Math.round(100 / audio.duration * bufferedStart) || 0, "%"),
            width: "".concat(Math.round(100 / audio.duration * (bufferedEnd - bufferedStart)) || 0, "%")
          });
        }

        clearTimeout(_this2.downloadProgressAnimationTimer);

        _this2.setState({
          downloadProgressArr: downloadProgressArr,
          hasDownloadProgressAnimation: true
        });

        _this2.downloadProgressAnimationTimer = setTimeout(function () {
          _this2.setState({
            hasDownloadProgressAnimation: false
          });
        }, 200);
      });
      audio.addEventListener('timeupdate', H5AudioPlayer.throttle(function (e) {
        var isDraggingProgress = _this2.state.isDraggingProgress;
        var audio = e.target;
        if (isDraggingProgress) return;
        var duration = audio.duration,
            currentTime = audio.currentTime;

        _this2.setState({
          currentTimePos: "".concat((currentTime / duration * 100 || 0).toFixed(2), "%")
        });
      }, this.props.progressUpdateInterval));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.volumeAnimationTimer);
      clearTimeout(this.downloadProgressAnimationTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          className = _this$props.className,
          src = _this$props.src,
          preload = _this$props.preload,
          autoPlay = _this$props.autoPlay,
          crossOrigin = _this$props.crossOrigin,
          mediaGroup = _this$props.mediaGroup,
          showLoopControl = _this$props.showLoopControl,
          showVolumeControl = _this$props.showVolumeControl,
          showSkipControls = _this$props.showSkipControls,
          showJumpControls = _this$props.showJumpControls,
          onClickPrevious = _this$props.onClickPrevious,
          onClickNext = _this$props.onClickNext,
          showDownloadProgress = _this$props.showDownloadProgress,
          volumeProp = _this$props.volume,
          children = _this$props.children,
          style = _this$props.style;
      var _this$state2 = this.state,
          currentTimePos = _this$state2.currentTimePos,
          currentVolumePos = _this$state2.currentVolumePos,
          isPlaying = _this$state2.isPlaying,
          isLoopEnabled = _this$state2.isLoopEnabled,
          downloadProgressArr = _this$state2.downloadProgressArr,
          hasVolumeAnimation = _this$state2.hasVolumeAnimation,
          hasDownloadProgressAnimation = _this$state2.hasDownloadProgressAnimation;

      var _ref = this.audio || {},
          _ref$currentTime = _ref.currentTime,
          currentTime = _ref$currentTime === void 0 ? 0 : _ref$currentTime,
          _ref$duration = _ref.duration,
          duration = _ref$duration === void 0 ? 0 : _ref$duration,
          _ref$volume = _ref.volume,
          volume = _ref$volume === void 0 ? volumeProp : _ref$volume;

      return React.createElement("div", {
        role: "group",
        tabIndex: 0,
        "aria-label": "Audio Player",
        className: "rhap_container ".concat(className),
        onKeyDown: this.handleKeyDown,
        ref: function ref(_ref6) {
          _this3.container = _ref6;
        },
        style: style
      }, React.createElement("audio", {
        src: src,
        controls: false,
        loop: isLoopEnabled,
        autoPlay: autoPlay,
        preload: preload,
        crossOrigin: crossOrigin,
        mediaGroup: mediaGroup,
        ref: function ref(_ref2) {
          _this3.audio = _ref2;
        }
      }, children), React.createElement("div", {
        className: "rhap_progress-section"
      }, React.createElement("div", {
        id: "rhap_current-time",
        className: "rhap_time rhap_current-time"
      }, H5AudioPlayer.getDisplayTimeBySeconds(currentTime)), React.createElement("div", {
        className: "rhap_progress-container",
        ref: function ref(_ref4) {
          _this3.progressBar = _ref4;
        },
        "aria-label": "Audio Progress Control",
        "aria-describedby": "rhap_current-time",
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": Number(currentTimePos.split('%')[0]),
        tabIndex: 0,
        onMouseDown: this.handleMouseDownProgressBar,
        onTouchStart: this.handleMouseDownProgressBar
      }, React.createElement("div", {
        className: "rhap_progress-bar ".concat(showDownloadProgress ? 'rhap_progress-bar-show-download' : '')
      }, React.createElement("div", {
        className: "rhap_progress-indicator",
        style: {
          left: currentTimePos
        }
      }), showDownloadProgress && downloadProgressArr.map(function (_ref3, i) {
        var left = _ref3.left,
            width = _ref3.width;
        return React.createElement("div", {
          key: i,
          className: "rhap_download-progress",
          style: {
            left: left,
            width: width,
            transitionDuration: hasDownloadProgressAnimation ? '.2s' : '0s'
          }
        });
      }))), React.createElement("div", {
        className: "rhap_time rhap_total-time"
      }, H5AudioPlayer.getDisplayTimeBySeconds(duration))), React.createElement("div", {
        className: "rhap_controls-section"
      }, React.createElement("div", {
        className: "rhap_additional-controls"
      }, showLoopControl && React.createElement("button", {
        "aria-label": isLoopEnabled ? 'Enable Loop' : 'Disable Loop',
        className: "rhap_button-clear rhap_repeat-button",
        onClick: this.handleClickLoopButton
      }, React.createElement(Icon, {
        icon: isLoopEnabled ? repeat : repeatOff
      }))), React.createElement("div", {
        className: "rhap_main-controls"
      }, showSkipControls && React.createElement("button", {
        "aria-label": "Previous",
        className: "rhap_button-clear rhap_main-controls-button rhap_skip-button",
        onClick: onClickPrevious
      }, React.createElement(Icon, {
        icon: skipPrevious
      })), showJumpControls && React.createElement("button", {
        "aria-label": "Rewind",
        className: "rhap_button-clear rhap_main-controls-button rhap_rewind-button",
        onClick: this.handleClickRewind
      }, React.createElement(Icon, {
        icon: rewind
      })), React.createElement("button", {
        "aria-label": isPlaying ? 'Pause' : 'Play',
        className: "rhap_button-clear rhap_main-controls-button rhap_play-pause-button",
        onClick: this.togglePlay
      }, isPlaying ? React.createElement(Icon, {
        icon: pauseCircle
      }) : React.createElement(Icon, {
        icon: playCircle
      })), showJumpControls && React.createElement("button", {
        "aria-label": "Forward",
        className: "rhap_button-clear rhap_main-controls-button rhap_forward-button",
        onClick: this.handleClickForward
      }, React.createElement(Icon, {
        icon: fastForward
      })), showSkipControls && React.createElement("button", {
        "aria-label": "Skip",
        className: "rhap_button-clear rhap_main-controls-button rhap_skip-button",
        onClick: onClickNext
      }, React.createElement(Icon, {
        icon: skipNext
      }))), React.createElement("div", {
        className: "rhap_volume-controls"
      }, showVolumeControl && React.createElement("div", {
        className: "rhap_volume-container"
      }, React.createElement("button", {
        "aria-label": volume ? 'Mute' : 'Unmute',
        onClick: this.handleClickVolumeButton,
        className: "rhap_button-clear rhap_volume-button"
      }, React.createElement(Icon, {
        icon: volume ? volumeHigh : volumeMute
      })), React.createElement("div", {
        ref: function ref(_ref5) {
          _this3.volumeControl = _ref5;
        },
        onMouseDown: this.handleVolumnControlMouseDown,
        onTouchStart: this.handleVolumnControlMouseDown,
        role: "progressbar",
        "aria-label": "volume Control",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": Number((volume * 100).toFixed(0)),
        tabIndex: 0,
        className: "rhap_volume-bar-area"
      }, React.createElement("div", {
        className: "rhap_volume-bar"
      }, React.createElement("div", {
        className: "rhap_volume-indicator",
        style: {
          left: currentVolumePos,
          transitionDuration: hasVolumeAnimation ? '.1s' : '0s'
        }
      })))))));
    }
  }]);

  return H5AudioPlayer;
}(Component);

_defineProperty(H5AudioPlayer, "defaultProps", {
  autoPlay: false,
  autoPlayAfterSrcChange: true,
  listenInterval: 1000,
  progressJumpStep: 5000,
  volumeJumpStep: 0.1,
  loop: false,
  muted: false,
  preload: 'auto',
  progressUpdateInterval: 20,
  volume: 1.0,
  className: '',
  showLoopControl: true,
  showVolumeControl: true,
  showJumpControls: true,
  showSkipControls: false,
  showDownloadProgress: true
});

export default H5AudioPlayer;